import React from 'react';
import type {
  ImageProps as RNImageProps,
  StyleProp,
  ImageStyle,
} from 'react-native';
import { StyleSheet, Image as RNImage } from 'react-native';

import { AspectView } from '../../AspectView';

export const ResponsiveImage = (props: RNImageProps) => {
  const { style, ...rest } = props;
  const { ratio, otherStyles } = extractRatioFromStyles([style]);

  return (
    <AspectView style={{ aspectRatio: ratio }}>
      <RNImage
        style={[styles.responsiveImageFill, otherStyles]}
        accessibilityIgnoresInvertColors
        {...rest}
      />
    </AspectView>
  );
};

const styles = StyleSheet.create({
  responsiveImageFill: { width: '100%', height: '100%' },
});

const extractRatioFromStyles = (stylesArray: StyleProp<ImageStyle>) => {
  const { width, height, ...otherStyles } = StyleSheet.flatten(stylesArray);

  if (otherStyles?.aspectRatio) {
    return { ratio: otherStyles?.aspectRatio, otherStyles };
  }

  if (typeof height !== 'number' || width !== 'number') {
    return { ratio: 1, otherStyles };
  }

  const ratio = Number(height) / Number(width);

  return { ratio, otherStyles };
};
